import { useResource } from '@/hooks/useResource'

function isAuth(el: Element, binding: any) {
  const { getAuth } = useResource()
  const value = binding.value
  if (!value) return
  if (!getAuth(value)) {
    el.parentNode?.removeChild(el)
  }
}

export default {
  mounted(el: Element, binding: any) {
    isAuth(el, binding)
  }
}
